import { render, staticRenderFns } from "./TablePermanentlyDeleted.vue?vue&type=template&id=3a2bef02&scoped=true"
import script from "./TablePermanentlyDeleted.vue?vue&type=script&lang=js"
export * from "./TablePermanentlyDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2bef02",
  null
  
)

export default component.exports